// Whiskey: the cowboy's heal. The Godot game's stim (scripts/player/player.gd _handle_stim_input /
// _tick_stim), presented as Godot presented it: he pulls a bottle from his belt, chugs it, and tosses
// the empty so it shatters (client/render/whiskey.ts draws that; the sim only knows the timings).
//
// Godot's rules, unchanged:
//  * a run starts with one bottle; every new island you reach adds one, up to five. Bottles stay in
//    your belt through a death (a lost life is the price already). The +1 STIM power-up adds one.
//  * the chug takes one second: you walk at 0.3x and can't shoot, aim, reload, melee, throw, roll,
//    jump or swap. Getting downed spills it (the bottle is spent).
//  * then ten seconds of 10 HP a second (a full hull) and adrenaline: move x1.3 on foot, melee
//    damage x1.2 and melee cadence x0.75. No second bottle while one is working.

import { secs } from './core';

export const WHISKEY_START = 1;
export const WHISKEY_PER_ISLAND = 1;
export const WHISKEY_MAX = 5;
/** the chug: locked out of every verb but walking */
export const CHUG_TICKS = secs(1);
export const CHUG_WALK_MUL = 0.3;
/** the heal that follows, and the adrenaline that rides with it */
export const HEAL_TICKS = secs(10);
export const HEAL_HPS = 10;
export const ADREN_SPEED = 1.3;
export const ADREN_MELEE = 1.2;
export const ADREN_MELEE_CD = 0.75;

/**
 * How he gets rid of the empty (James, 2026-10-21: "a few different funny ways"). Purely a show, but every
 * screen must show the same one, so the server rolls it and it rides on the drink event. Never the same one
 * twice in a row for the same cowboy.
 */
export const enum Ditch { Side = 0, Shoulder, Spike, Flip, Drop }
export const DITCH_COUNT = 5;
/** a roll in [0, 1) and the cowboy's last pick -> this pick */
export function rollDitch(r: number, prev: number) {
  const k = Math.floor(r * (prev >= 0 ? DITCH_COUNT - 1 : DITCH_COUNT));
  return prev >= 0 && k >= prev ? k + 1 : k;
}
